var infraestructuras = angular.module('infraestructuras');

infraestructuras.controller('infraestructurasController', ['$rootScope', '$scope', '$location', 'infraestructurasService', '$routeParams', 'authenticationInfo', 'authenticationService', '$sce', '$timeout',

    function ($rootScope, $scope, $location, infraestructurasService, $routeParams, authenticationInfo, authenticationService, $sce, $timeout
 ) {

        $scope.authentication = authenticationInfo;

        $rootScope.categoria = $routeParams.id;

        $scope.categoria = $routeParams.id;

        
    }]);

